import { Injectable, inject } from '@angular/core';

import {
    EventsService,
    LoginResponseHandlerService,
    LoginStoreService,
    LoginType,
    Message,
    NativeAppService,
    NativeEventType,
    UserLoggingInEvent,
    UserService,
    VanillaEventNames,
} from '@frontend/vanilla/core';
import { Subject } from 'rxjs';

import { LoginResourceService } from '../login-resource.service';
import { LoginService } from '../login.service';
import { BetstationLoginErrorOverlayService } from './betstation-login-error-overlay.service';
import { GridConnectLoginRequest } from './betstation-login.models';

@Injectable({ providedIn: 'root' })
export class BetstationLoginService {
    onIncorrectPin: Subject<string> = new Subject();

    private betstationLoginErrorOverlayService = inject(BetstationLoginErrorOverlayService);
    private loginResourceService = inject(LoginResourceService);
    private loginResponseHandlerService = inject(LoginResponseHandlerService);
    private loginService = inject(LoginService);
    private loginStoreService = inject(LoginStoreService);
    private nativeAppService = inject(NativeAppService);
    private userService = inject(UserService);
    private eventsService = inject(EventsService);

    gridConnectLogin(data: GridConnectLoginRequest, onComplete: () => void) {
        this.userService.triggerEvent(new UserLoggingInEvent());

        this.loginStoreService.LastVisitor = data.connectCardNumber;

        if (data.loyaltyLoginEnabled) {
            this.eventsService.raise({ eventName: VanillaEventNames.GridConnectLogin, data });
            onComplete();
        } else {
            this.loginResourceService
                .login(data, { showSpinner: false })
                .subscribe({
                    next: (data) => {
                        this.nativeAppService.sendToNative({
                            eventName: NativeEventType.PRELOGIN,
                            parameters: {
                                userName: data.username || data.connectCardNumber,
                                password: data.password || data.pin,
                                loginType: data.loginType,
                            },
                        });

                        this.loginResponseHandlerService.handle(data).then((redirectInfo) => {
                            redirectInfo.goTo();
                        });
                    },
                    error: async (error) => {
                        await this.loginService.loginFailed({ reason: error, type: LoginType.ConnectCard });
                        if (error.vnMessages?.length > 0) {
                            const message = error.vnMessages[0] as Message;
                            //Do not close or show default error dialog when error is invalid attempts to block.
                            if (error.errorValues?.some((x: any) => x.key === 'REM_INVALID_PSWD_LOGIN_ATTEMPTS_TO_PSWD_BLOCK')) {
                                this.onIncorrectPin.next(message.html);
                            } else {
                                this.betstationLoginErrorOverlayService.showLoginErrorOverlay(message.html);
                            }
                        }
                    },
                })
                .add(() => {
                    onComplete();
                });
        }
    }
}
